// src/api/apiClient.js
import axios from "axios";
import { getToken, forceLogout } from "../context/AuthContext";

// Root backend URL
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// -------- PUBLIC CLIENT (no JWT needed) --------
export const authClient = axios.create({
  baseURL: BASE_URL,
});

// -------- PRIVATE CLIENT (JWT must be attached manually) --------
export const apiClient = axios.create({
  baseURL: BASE_URL,
});

// -------- Helper: attach JWT (no interceptors used) --------
export function attachJwt(config = {}) {
  const token = getToken();

  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
}

// -------- Base GET --------
export async function apiGet(url) {
  try {
    return await apiClient.get(url, attachJwt());
  } catch (err) {
    if (err.response?.status === 401) {
      forceLogout();          // <--- calls React logout safely
      window.location.href = "/login";
    }
    throw err;   // Re-throw so local code can also handle it
  }
}


// -------- Base POST --------
export function apiPost(url, data) {
  return apiClient.post(url, data, attachJwt());
}

// -------- Base DELETE --------
export async function apiDelete(url) {
  try {
    return await apiClient.delete(url, attachJwt());
  } catch (err) {
    if (err.response?.status === 401) {
      forceLogout();
      window.location.href = "/login";
    }
    throw err;
  }
}

// -------- Base PUT --------
export async function apiPut(url, data) {
  try {
    return await apiClient.put(url, data, attachJwt());
  } catch (err) {
    if (err.response?.status === 401) {
      forceLogout();
      window.location.href = "/login";
    }
    throw err;
  }
}

